import { useTranslation } from "react-i18next";
import { TableMenu } from "components";
import RCAConfirmDeleteModal from "pages/Corporate/RCA/components/RCAConfirmDeleteModal/RCAConfirmDeleteModal";
import { useMemo, useState } from "react";
import moment from "moment";
import { IOption } from "components/TableMenu/TableMenuInterfaces";
import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import useRolesPermissions from "hooks/useRolesPermissions";
import { IRCA } from "entities/RCA/RCALibraryEntity/RCALibraryEntityInterfaces";
import { RCALibraryEntity } from "entities/RCA/RCALibraryEntity/RCALibraryEntity";

const RCALibraryOptionsMenuCell = ({
    rca,
    refetch,
}: {
    rca: IRCA;
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
}) => {
    const { t } = useTranslation();
    const [openIsRCADeleteModal, setOpenRCADeleteModal] = useState<boolean>(false);
    const { upsertSetRCAWithTeamMembers } = RCALibraryEntity.UpsertRCAWithTeamMembers();

    const rcaOwnershipIds = useMemo(
        () =>
            rca
                ? [
                      ...(rca?.owner?.user_id ? [rca.owner.user_id] : []),
                      ...(rca?.created_by ? [rca?.created_by] : []),
                      ...(rca?.rca_team_members ? rca?.rca_team_members?.map((rtm) => rtm.user.user_id) : []),
                  ]
                : [],
        [rca],
    );
    const { RCA_PERMISSIONS } = useRolesPermissions(rcaOwnershipIds);

    const handleDeleteRCA = async () => {
        const rcaDetailValues = {
            deleted_at: moment.utc().toDate(),
        };

        try {
            await upsertSetRCAWithTeamMembers({
                variables: {
                    rcaId: rca.rca_id,
                    rcaChanges: rcaDetailValues,
                    rca_team_members: [],
                },
            });
            refetch();
        } catch {
            return;
        }
    };

    const options: IOption[] = [
        {
            name: t("rca.rca_library.rca_detail.delete_rca"),
            callback: () => setOpenRCADeleteModal(true),
            disabled: !RCA_PERMISSIONS?.rca_library?.canDelete,
        },
    ];

    return (
        <div>
            <TableMenu options={options} />{" "}
            <RCAConfirmDeleteModal
                open={openIsRCADeleteModal}
                onClose={() => setOpenRCADeleteModal(false)}
                onDeleteItem={handleDeleteRCA}
                title={t("rca.rca_library.rca_detail.rca_delete_modal.title")}
                warning={t("rca.rca_library.rca_detail.rca_delete_modal.warning")}
                confirm={t("rca.rca_library.rca_detail.rca_delete_modal.confirm")}
            />
        </div>
    );
};

export default RCALibraryOptionsMenuCell;
